const list = {
  // =================================================================================================================
  search: {},
  components() {
    return [
      {
        component: "search-year",
        label: "연도",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
          afterFix: "년",
          gridTemplateColumns: "39px 138px",
          onChange: (value) => {
            if (value !== "") {
              list.search.half = "";
              list.search.quarter = "";
              list.search.month = "";
            }
          },
        },
      },
      {
        'component': 'search-year-half', label: '반기', value: 'half', query: {'y_h': 'half'},
        options: {
          default: '',
          onChange: (value) => {
            list.search.half = value;
            if (value !== "") {
              list.changeHandler("half", value);
            }
          },
        }
      },
      {
        'component': 'search-year-quarter', label: '분기', value: 'quarter', query: {'y_q': 'quarter'},
        options: {
          default: '',
          onChange: (value) => {
            list.search.quarter = value;
            if (value !== "") {
              list.changeHandler("quarter", value);
            }
          },
        }
      },
      {
        'component': 'search-month', label: '월', value: 'month', query: {'y_m': 'month'},
        options: {
          default: '',
          onChange: (value) => {
            list.search.month = value;
            if (value !== "") {
              list.changeHandler("month", value);
            }
          },
        }
      },

      {'component': 'empty-space'},

      {
        'component': 'search-start-end',
        label: '평가일',
        value: 'date',
        query: {'ss': 'startDate', 'ee': 'endDate'},
        options: {
          default: {sd: '', ed: ''},
        }
      },
      {'component': 'search-disaster-types', label: '재해형태', value: 'disaster', query: {'dty': 'disaster'}, options: {}},
      {
        'component': 'search-column-keyword',
        label: '검색조건',
        value: 'column',
        query: {'ck_t': 'head', 'ck_k': 'keyword'},
        options: {hiddenList: ['부서명', '재해형태', '평가일']}
      },
    ]
  },

  changeHandler(type, value) {
    if (type === "month") {
      list.search.quarter = "";
      list.search.half = "";
    } else if (type === "quarter") {
      list.search.month = "";
      list.search.half = "";
    } else if (type === "half") {
      list.search.month = "";
      list.search.quarter = "";
    }
  },

  getConditions: (nav) => {
    const conditions = [];
    list.search = nav.value;

    if (list.search.year) {
      conditions.push({key: 'body.inputB_4', operator: '>=', value: `${list.search.year}-01-01`})
      conditions.push({key: 'body.inputB_4', operator: '<=', value: `${list.search.year}-12-31`})
    }

    if (list.search.half) {
      if (list.search.half === '상반기') {
        conditions.push({key: 'body.inputB_4', operator: '>=', value: `${list.search.year}-01-01`})
        conditions.push({key: 'body.inputB_4', operator: '<=', value: `${list.search.year}-06-30`})
      }
      else if (list.search.half === '하반기') {
        conditions.push({key: 'body.inputB_4', operator: '>=', value: `${list.search.year}-07-01`})
        conditions.push({key: 'body.inputB_4', operator: '<=', value: `${list.search.year}-12-31`})
      }
    }

    if (list.search.quarter) {
      console.log(list.search.quarter);
      if (list.search.quarter === 1) {
        conditions.push({key: 'body.inputB_4', operator: '>=', value: `${list.search.year}-01-01`})
        conditions.push({key: 'body.inputB_4', operator: '<=', value: `${list.search.year}-03-31`})
      }
      else if (list.search.quarter === 2) {
        conditions.push({key: 'body.inputB_4', operator: '>=', value: `${list.search.year}-04-01`})
        conditions.push({key: 'body.inputB_4', operator: '<=', value: `${list.search.year}-06-30`})
      }
      else if (list.search.quarter === 3) {
        conditions.push({key: 'body.inputB_4', operator: '>=', value: `${list.search.year}-07-01`})
        conditions.push({key: 'body.inputB_4', operator: '<=', value: `${list.search.year}-09-30`})
      }
      else if (list.search.quarter === 4) {
        conditions.push({key: 'body.inputB_4', operator: '>=', value: `${list.search.year}-10-01`})
        conditions.push({key: 'body.inputB_4', operator: '<=', value: `${list.search.year}-12-31`})
      }
    }

    if (list.search.month) {
      const month = String(list.search.month).padStart(2, '0');
      const startDate = `${list.search.year}-${month}-01`;
      const endDate = new Date(list.search.year, parseInt(month), 0).getDate(); // 해당 월의 마지막 날짜
      conditions.push({key: 'body.inputB_4', operator: '>=', value: startDate})
      conditions.push({key: 'body.inputB_4', operator: '<=', value: `${list.search.year}-${month}-${endDate}`})
    }

    //  평가일
    if (list.search.date) {
      conditions.push({key: 'body.inputB_4', operator: '>=', value: list.search.date.startDate})
      conditions.push({key: 'body.inputB_4', operator: '<', value: list.search.date.endDate ? new Date(list.search.date.endDate).addDays(1).format("yyyy-MM-dd") : ''})
    }

    //  재해형태
    if (list.search.disaster) {
      // riskAppraisalList 으로 검색 되도록 수정해야함
      conditions.push({key: 'body.disasters', operator: 'LIKE', value: `%${list.search.disaster}%`})
    }

    //  검색조건
    const heads = list.getHead().map(e => {return {[e.name] : e.key}});
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (list.search.column && list.search.column.keyword) {
      conditions.push({key: types[list.search.column.head], operator: 'LIKE', value: `%${list.search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {
        "name": "부서명",
        "key": "field.com_name",
        "sortKey": false
      },
      {
        "name": "팀명",
        "key": "field.team_company_list[%].com_name",
        "sortKey": false
      },
      {
        "name": "사업장명",
        "key": "body.stdInfo.field_name"
      },
      {
        "name": "작업내용",
        "key": "body.inputB_3"
      },
      {
        "name": "재해형태",
        "key": "body.disasters"
      },
      {
        "name": "평가일",
        "key": "body.inputB_4"
      },
      {
        "name": "소속명",
        "key": "body.stdInfo.department"
      },
      {
        "name": "작성자",
        "key": "body.stdInfo.writer_name"
      }
    ]
  },
  getCol: (index, value, func) => {
    const disasters = func.getContent(value).disasters || '';
    const disasterSplit = disasters.trim().split(' ');
    // disasters 배열 중에서 중복된 항목을 제거한다
    const uniqueDisasters = [...new Set(disasterSplit)];
    // 오름차순 정렬
    uniqueDisasters.sort();

    try {
      switch (index) {
        case 0: {
          const meta = JSON.parse(value.field.meta || '{}')
          return func.getContent(value).stdInfo.부서명_과 || meta.com_name // 부서명_과
        }
        case 1: {
          const team_company_list = JSON.parse(value.field.meta || '{}').team_company_list;
          return team_company_list ? team_company_list.map(team => team.com_name).join(', ') : '-';
        }
        case 2: return func.getContent(value).stdInfo.field_name // 사업장명
        case 3: return func.getContent(value).inputB_3 // 작업내용
        case 4: return uniqueDisasters.join(', ') // 재해형태
        case 5: return func.getContent(value).inputB_4 // 평가일
        case 6: return func.getContent(value).stdInfo.department // 소속명
        case 7: return func.getContent(value).stdInfo.writer_name // 작성자
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
  getDefaultSort: () => {
    return {target: 'content$body.inputB_4', order: 'desc'};
  },
}
export default list;
